import React, {useState} from 'react'
import { SelectInline, InputInline } from '@arnsbogroup/react-voicearchive'
import {
  FILE_NAMING_PRESETS,
  FILE_NAMING_OPTIONS,
  FileNamingMarkers,
  getFileNamingPreset,
} from 'components/FileNaming'

const FileSettings = ( {customer, onChange} ) => {
  if (!customer) {
    return null
  }

  const [convention, setConvention] = useState(customer.filenameConvention);

  function changeFilenameConventionHandler(value) {
    setConvention(value);
    
    fetch(`/rest/v2/customer/filenameConvention?customerId[]=${customer.uid}`,
    {
      method: 'PUT',
      body: JSON.stringify({filename: value}),
    })
      .then(() => {
        onChange(customer, true); // force refresh to fetch new updated file name convention
      });
  }


  return (
    <div className='p-4'>
      <div className='mb-6'>
        <SelectInline
          labelClassName="text-xs"
          label="Automatically send talent files to the client on new orders"
          placeholder="Automatically send talent files to the client on new orders"
          value={ { value: customer.autoDeliverSupplierFiles, label: (customer.autoDeliverSupplierFiles == '1') ? 'Yes' : 'No' } }
          options={[
            { value: '1', label: 'Yes' },
            { value: '0', label: 'No' },
          ]}
          onChange={(selection) => { onChange({ ...customer, autoDeliverSupplierFiles: selection.value }) } }
        />
      </div>

      <div className='mb-6'>
        <SelectInline
          labelClassName="text-xs"
          label="Push client-approved files to the customer's delivery destinations"
          placeholder="Push client-approved files to the customer's delivery destinations"
          value={ { value: customer.allowAutoDelivery, label: (customer.allowAutoDelivery == '1') ? 'Yes' : 'No' } }
          options={[
            { value: '1', label: 'Yes' },
            { value: '0', label: 'No' },
          ]}
          onChange={(selection) => { onChange({ ...customer, allowAutoDelivery: selection.value }) } } 
        />
      </div>

      <div className='mb-2'>
        <h1>File Naming convention for customer files</h1>

        <div className='my-4'>
          <SelectInline
            labelClassName="text-xs"
            label="File naming preset"
            placeholder="File naming preset"
            value={ getFileNamingPreset(convention) }
            options={FILE_NAMING_OPTIONS}
            onChange={(selection) => {
              changeFilenameConventionHandler(FILE_NAMING_PRESETS[selection.value] ?? '');
            } } 
          />
        </div>

        <div className="mb-4">
          <InputInline 
            labelClassName="text-xs"
            label="File naming convention"
            placeholder="File naming convention"
            value={ convention }
            onChange={({ target: { value } }) => {
              changeFilenameConventionHandler(value);
            }}
          />
        </div>
        
      </div>

      <FileNamingMarkers />
    </div>
  )
}

export default FileSettings
